// extracted by mini-css-extract-plugin
export var section = "styles-module--section--TrKGr";
export var title = "styles-module--title--3lv8C";
export var container = "styles-module--container--1MFRU";
export var subtitle = "styles-module--subtitle--2E6yB";
export var image = "styles-module--image--2uTvW";